import PaymentAction from './paymentAction';
import { paymentInitialState } from './paymentState';

export default (state, action) => {
  switch (action.type) {
    case PaymentAction.GET_TOKEN_LOADING:
      return {
        ...state,
        isLoading: true
      };
    case PaymentAction.GET_TOKEN_LOADED:
      return {
        ...state,
        isLoading: false
      };
    case PaymentAction.PAYMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true
      };
    case PaymentAction.PAYMENT_FAILED:
      return {
        ...state,
        isLoading: false,
        isError: true
      };
    case PaymentAction.SUBMIT_TRANSACTION:
      return {
        ...state,
        isSubmitted: true,
      };
    case PaymentAction.RESET_TRANSACTION:
      return {...state, ...paymentInitialState};
    default:
      return {...state};
  }
};
